import ItemFilter, { type FilterOption } from './ItemFilter';

export type ProgramIncrementId = string;

export default class ProgramIncrementFilter extends ItemFilter<ProgramIncrementId> {
  constructor({
    initialItems = [],
    initialOptions = [],
  }: {
    initialItems?: ProgramIncrementId[];
    initialOptions?: FilterOption<ProgramIncrementId>[];
  } = {}) {
    super(initialItems, initialOptions);
  }

  updateProgramIncrementOptions(
    programIncrements: Array<{ id: string; name: string }>
  ) {
    const options: FilterOption<ProgramIncrementId>[] = programIncrements.map(
      pi => ({
        text: pi.name,
        value: pi.id,
        label: pi.name,
      })
    );
    this.setOptions(options);
  }
}
